<div class="page-body">
  <div *ngIf="loadingPreFillInfoFromServer || navigating || loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!(loadingPreFillInfoFromServer || navigating) && !loading">
    <div
      *ngIf="paymentRequest && !paymentRequest.specificPaymentMethod"
      class="banner"
    >
      <button type="button" class="back-button" (click)="reroute()">
        
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span>Tillbaka</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <div class="page-icon">
          <app-zaver-icon [size]="92" name="bankIDse" ></app-zaver-icon>
        </div>
        <div
          *ngIf="authInProgress && (!isMobile || showQrCode)"
          class="open-app-text"
        >
          Vänligen öppna din BankID-app för att fortsätta
        </div>

        <ng-container *ngIf="!showQrCode">
          <!-- Temporary solution for users on the Tibber App  -->
          <zaver-alert-box
            *ngIf="authInProgress && isTibberApp"
            type="INFO"
            [messageList]="getTibberAppMessageList()"
            (click)="copyCheckoutLinkToClipboard()"
          ></zaver-alert-box>

          <span *ngIf="authInProgress" class="status-message">
            {{ bankIdStatusMessage }}
          </span>

          <div *ngIf="authInProgress && isMobile">
            <zaver-loading-dots [color]="'#b7bcc8'"></zaver-loading-dots>
          </div>

          <div
            class="deeplink-button-container"
            *ngIf="authInProgress && manualDeeplinkEnabled"
          >
            <div class="deeplink-button" (click)="autoStartAppClick()">
              Öppna BankID appen
            </div>
          </div>

          <div
            class="alert-container"
            *ngIf="!authInProgress && authErrorMessageList"
          >
            <zaver-alert-box
              type="WARNING"
              [messageList]="authErrorMessageList"
            ></zaver-alert-box>
          </div>

          <div class="try-again-button-container" *ngIf="!authInProgress">
            <zaver-primary-button
              [text]="tryAgainButtonText"
              (click)="autoStartAppClick()"
              [logo]="'assets/icon/BankID-Vector-Logo-White.svg'"
            ></zaver-primary-button>
          </div>

          <a class="second-option-link" (click)="showQrCodeClick()">
            <u>{{ useDifferentDeviceButtonText }}</u>
          </a>
        </ng-container>

        <ng-container *ngIf="showQrCode">
          <div [hidden]="!authInProgress" class="qr-container">
            <div class="qr" #canvas></div>
          </div>

          <span *ngIf="authInProgress" class="status-message">
            {{ bankIdStatusMessage }}
          </span>

          <div
            class="alert-container"
            *ngIf="!authInProgress && authErrorMessageList"
          >
            <zaver-alert-box
              type="WARNING"
              [messageList]="authErrorMessageList"
            ></zaver-alert-box>
          </div>

          <div
            class="try-again-button-container"
            *ngIf="!authInProgress && authErrorMessageList"
          >
            <zaver-primary-button
              [text]="tryAgainButtonText"
              (click)="showQrCodeClick()"
              [logo]="'assets/icon/BankID-Vector-Logo-White.svg'"
            ></zaver-primary-button>
          </div>

          <a class="second-option-link" (click)="autoStartAppClick()">
            <u>{{ useThisDeviceButtonText }}</u>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>
